import {useSelector} from "react-redux";

import AppreciationTabInputText from "../../component/appreciation/AppreciationTabInputText";
import MissingDataIndicator from "../../component/MissingDataIndicator";
import {selectPersistenceInitialized} from "../../redux/persistenceSlice";
import {
    selectComparativeValueAvailable,
    selectComparativeValueData,
    selectLoading,
} from "../../redux/valueIndicationSlice";
import PersistenceFinalMessage from "../object/PersistenceFinalMessage";
import SnapshotMessage from "../object/SnapshotMessage";
import IndicationTable from "./IndicationTable";

export default function TabComparativeValueIndication() {
    const comparativeValueData = useSelector(selectComparativeValueData);
    const comparativeValueAvailable = useSelector(selectComparativeValueAvailable);
    const loading = useSelector(selectLoading);
    const persistenceInitialized = useSelector(selectPersistenceInitialized);

    return (
        <>
            <MissingDataIndicator dataAvailable={comparativeValueAvailable || loading || !persistenceInitialized} />
            <PersistenceFinalMessage />
            <SnapshotMessage />
            <AppreciationTabInputText page="value" tab="comparative_value" />
            <IndicationTable endpoint="COMPARATIVE_VALUE" indicationDetails={comparativeValueData} />
        </>
    );
}
